import router from "./router";
import store from "./store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken, removeToken } from "@/utils/auth";

NProgress.configure({ showSpinner: false });

const whiteList = ["/login", "/auth-redirect", "/ocr-discern", "/ocr", "/wxBank", "/wxBank/info", "/signLand", "/ocr_p"];

export const nameList = new Map([
  ["/wxBank", "收款账户"],
  ["/wxBank/info", "添加收款账户"],
  ["/ocr", "签约平台"],
  ["/signLand", "合同准备中"],
  ["/ocr_p", "合同准备中"]
]);

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  let onLogin = [];

  if (to.path === "/login" && to.fullPath.split("loginKey").length === 2) {
    onLogin = to.fullPath.split("loginKey");
    removeToken();
  }

  if (nameList.has(to.path)) {
    document.title = nameList.get(to.path);
  }

  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      if (hasRoles) {
        if (to.meta.returnFirst) {
          const menuList = store.state.user.menuList;
          const path = (menuList[0].fpath === "/" ? "" : menuList[0].fpath) + "/" + menuList[0].path;
          if (from.fullPath === path) {
            next();
            window.location.reload();
          } else {
            next({ path });
          }
        } else {
          if (!to.meta.allow) {
            if (to.path === "/") {
              next({ path: "/goIndex" });
            } else {
              next({ path: "/401" });
            }
          } else {
            next();
          }
        }
      } else {
        try {
          const data = await store.dispatch("user/getInfo");
          localStorage.setItem("routes", data.roles);
          if (data.redirect) {
            next({ ...data.redirect, replace: true });
          } else {
            next({ ...to, replace: true });
          }
        } catch (error) {
          await store.dispatch("user/resetToken");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      if (onLogin.length > 1) {
        const loginKey = onLogin[1].substring(1, onLogin[1].length);
        next(`/login?redirect=${to.path}&loginKey=${loginKey}`);
      } else {
        next(`/login?redirect=${to.path}`);
      }
      NProgress.done();
    }
  }
});

export function hasPermission(perms) {
  let hasPermission = false;
  const permission = store.getters.buttons;
  for (var i = 0; i < permission.length; i++) {
    if (permission[i] === perms) {
      hasPermission = true;
      break;
    }
  }
  return hasPermission;
}

export function getPermissionName(perms) {
  let result = "";
  const buttonNameList = store.getters.buttonName;
  for (let i = 0; i < buttonNameList.length; i++) {
    if (buttonNameList[i].apiPower === perms) {
      result = buttonNameList[i].label;
      break;
    }
  }
  return result;
}

router.afterEach(() => {
  NProgress.done();
});
